import React from 'react';
const pillBase = 'inline-flex items-center justify-center h-8 rounded-md';
export function PaymentLogos() {
  return <div className="space-y-3 pt-4" data-id="element-78">
      <p className="font-['Crimson_Text'] text-xs text-zinc-500 text-center" data-id="element-79">
        Pago seguro aceptado
      </p>
      <div className="flex items-center justify-center gap-2 flex-wrap max-w-xs sm:max-w-none mx-auto" data-id="element-80">
        {/* Shop Pay */}
        <span className={`${pillBase} px-3 py-1`} style={{
        backgroundColor: '#5A31F4'
      }} data-id="element-81">
          <span className="text-white text-[11px] font-bold tracking-wide" data-id="element-82">
            shop pay
          </span>
        </span>

        {/* PayPal */}
        <span className={`${pillBase} bg-white px-3 py-1`} data-id="element-83">
          <span className="text-[11px] font-bold italic" data-id="element-84">
            <span style={{
            color: '#003087'
          }} data-id="element-85">
              Pay
            </span>
            <span style={{
            color: '#009CDE'
          }} data-id="element-86">
              Pal
            </span>
          </span>
        </span>

        {/* Google Pay */}
        <span className={`${pillBase} bg-white px-2.5 py-1`} data-id="element-87">
          <span className="text-[11px] font-bold" data-id="element-88">
            <span style={{
            color: '#4285F4'
          }} data-id="element-89">
              G
            </span>
            <span style={{
            color: '#EA4335'
          }} data-id="element-90">
              o
            </span>
            <span style={{
            color: '#FBBC05'
          }} data-id="element-91">
              o
            </span>
            <span style={{
            color: '#4285F4'
          }} data-id="element-92">
              g
            </span>
            <span style={{
            color: '#34A853'
          }} data-id="element-93">
              l
            </span>
            <span style={{
            color: '#EA4335'
          }} data-id="element-94">
              e
            </span>
            <span className="text-zinc-600" data-id="element-95"> Pay</span>
          </span>
        </span>

        {/* Visa */}
        <span className={`${pillBase} bg-white px-3 py-1`} data-id="element-96">
          <span className="text-[13px] font-extrabold italic tracking-tight" style={{
          color: '#1A1F71'
        }} data-id="element-97">
            VISA
          </span>
        </span>

        {/* Mastercard */}
        <span className={`${pillBase} bg-white px-3 py-1`} data-id="element-98">
          <svg className="h-5 w-auto" viewBox="0 0 38 24" fill="none" data-id="element-99">
            <circle cx="15" cy="12" r="8" fill="#EB001B" data-id="element-100" />
            <circle cx="23" cy="12" r="8" fill="#F79E1B" data-id="element-101" />
            <path d="M19 5.6C20.9 7.1 22.2 9.4 22.2 12C22.2 14.6 20.9 16.9 19 18.4C17.1 16.9 15.8 14.6 15.8 12C15.8 9.4 17.1 7.1 19 5.6Z" fill="#FF5F00" data-id="element-102" />
          </svg>
        </span>

        {/* American Express */}
        <span className={`${pillBase} bg-white px-3 py-1`} data-id="element-103">
          <span className="text-[11px] font-extrabold tracking-wider" style={{
          color: '#2E77BC'
        }} data-id="element-104">
            AMEX
          </span>
        </span>
      </div>
    </div>;
}